/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import '../styles/radio-selector.scss';

const RadioSelector = ({
  onChange, label, checked, name, value, children, disabled,
}) => {
  const inputRef = useRef(null);

  const hasChildren = () => {
    if (children?.length && typeof children === 'object') {
      return children.some((it) => !!it);
    } if (children?.length === 0) {
      return false;
    }
    return !!children;
  };

  const classnameOption = classNames('radio-selector-group', {
    clickable: !hasChildren(),
    'radio-selector-group--checked': checked,
    'radio-selector-group--disabled': disabled,
  });

  return (
    <div
      className={classnameOption}
      onClick={!hasChildren()
        ? (e) => inputRef?.current && e.target !== inputRef.current && inputRef.current.click()
        : null}
      onKeyDown={!hasChildren()
        ? (e) => inputRef?.current && e.target !== inputRef.current && inputRef.current.click()
        : null}
    >
      <div className="radio-selector">
        <div className="radio-selector__label">{label}</div>
        <input
          ref={inputRef}
          className="radio-selector__radiobutton"
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      {children}
    </div>
  );
};

RadioSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

RadioSelector.defaultProps = {
  checked: false,
  value: null,
  children: null,
  disabled: false,
};

export default RadioSelector;
